import { AI_SEO_TITLE_MAX_LENGTH } from "@moderation-contract/thread-classification";
import { stripAllPua } from "@nijiurachan/pua-command";

export type ThreadMetadata = Readonly<{
  title: string;
  /** og:title用のブランド表記なしタイトル（OGPガイドライン準拠） */
  ogTitle: string;
  description: string;
  canonical: string;
}>;

export function stripThreadFormatting(value: string): string {
  return stripAllPua(value);
}

export function normalizeThreadText(value: string): string {
  return stripThreadFormatting(value)
    .replace(/<[^>]*>/g, " ")
    .replace(/&nbsp;/gi, " ")
    .replace(/\s+/g, " ")
    .trim();
}

function truncate(value: string, max: number): string {
  const chars = Array.from(value);
  return chars.length > max ? `${chars.slice(0, max).join("")}…` : value;
}

function truncateAiTitle(value: string): string {
  const chars = Array.from(value);
  return chars.length > AI_SEO_TITLE_MAX_LENGTH
    ? `${chars.slice(0, AI_SEO_TITLE_MAX_LENGTH - 1).join("")}…`
    : value;
}

/** Create identical metadata for the origin-rendered HTML and the SPA. */
export function createThreadMetadata(
  body: string,
  threadId: string,
  origin: string,
  siteName: string,
  publicBasePath: string,
  summary?: string | null,
  aiTitle?: string | null,
  hasAttachments = false,
): ThreadMetadata {
  const text = normalizeThreadText(body);
  const descriptionText = summary ? normalizeThreadText(summary) : "";
  const basePath = publicBasePath.replace(/\/+$/, "");
  const isImageOnlyKita = hasAttachments && body.trim() === "ｷﾀ━━━━(ﾟ∀ﾟ)━━━━!!";
  const normalizedAiTitle = aiTitle ? normalizeThreadText(aiTitle) : "";
  const ogTitle = isImageOnlyKita
    ? normalizedAiTitle
      ? truncateAiTitle(normalizedAiTitle)
      : `No.${threadId}`
    : text || `No.${threadId}`;
  return {
    title: `${ogTitle} - ${siteName}`,
    ogTitle,
    description: truncate(
      descriptionText || text || `${siteName}のスレッド`,
      80,
    ),
    canonical: new URL(
      `${basePath}/thread/${encodeURIComponent(threadId)}`,
      origin,
    ).toString(),
  };
}
